import { useEffect, useRef } from 'react';

export function useScrollLock(isLocked: boolean) {
  const originalOverflow = useRef<string>('');

  useEffect(() => {
    if (isLocked) {
      // Store the original overflow value
      originalOverflow.current = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else {
      // Restore the original overflow value
      document.body.style.overflow = originalOverflow.current;
    }

    // Cleanup function to ensure scroll is restored
    return () => {
      if (!isLocked) {
        document.body.style.overflow = originalOverflow.current;
      }
    };
  }, [isLocked]);

  // Function to force restore scroll
  const restoreScroll = () => {
    document.body.style.overflow = originalOverflow.current;
  };

  return { restoreScroll };
}

